import cls from 'classnames';

import { SingleToolFooter, SingleToolHeader, SingleToolSimilar } from '../../common';
import { Breadcrumb } from '../../core/Breadcrumb';
import { AppSwitcher } from '../../core';

import useStyles from './styles';
import { WithLandingProps } from './types';

function WithLanding({
  className,
  analytics,
  currentTool,
  breadcrumbs,
  switcherData,
  switcherSelected,
  switcherOnClick,
  switcherFirstItem,
  switcherLastItem,
  switcherQueryData,
  similarTools,
  toolCategory,
  mainArea = null,
  imageArea = null,
  otherContentArea = null,
  greyBreadcrumbsBackground,
}: WithLandingProps) {
  const classes = useStyles();

  return (
    <div className={className}>
      <SingleToolHeader
        analytics={analytics}
        className={classes.header}
        toolName={currentTool.id}
        widgetUrl={currentTool.widgetUrl}
      />
      <Breadcrumb
        items={breadcrumbs}
        className={cls(
          classes.breadcrumbs,

          greyBreadcrumbsBackground && classes.grey,
        )}
      />
      {switcherData && (
        <AppSwitcher
          className={classes.switcher}
          data={switcherData}
          selected={switcherSelected}
          onItemClick={switcherOnClick}
          firstItem={switcherFirstItem}
          lastItem={switcherLastItem}
          queryData={switcherQueryData}
        />
      )}

      {mainArea}
      {imageArea}
      {otherContentArea}

      {similarTools && (
        <SingleToolSimilar
          category={toolCategory}
          current={currentTool}
          paragraph="We hand-picked these tools for you because we believe they are relevant to your search and needs. Please go and check it out."
          similar={similarTools}
          analytics={analytics}
        />
      )}
      <SingleToolFooter analytics={analytics} />
    </div>
  );
}

export default WithLanding;
